module.exports = __webpack_public_path__ + "static/media/29COICT1.852990ea.jpg";